export { default } from './DocLink';
